var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card card-table flex-fill" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "table-responsive" }, [
        _c("table", { staticClass: "table custom-table mb-0" }, [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm.loading
                ? [
                    _c("tr", [
                      _c(
                        "td",
                        { attrs: { colspan: "3" } },
                        [_c("Skeleton", { attrs: { count: 1 } })],
                        1
                      )
                    ])
                  ]
                : [
                    _vm.rows.length > 0
                      ? [
                          _vm.rows.length
                            ? _vm._l(_vm.rows, function(row, index) {
                                return _c("tr", { key: index }, [
                                  _c("td", [_vm._v(_vm._s(row.title))]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      ref: "marketplace-" + row.id,
                                      refInFor: true,
                                      staticClass:
                                        "d-flex flex__gap-10 flex-wrap justify-content-center text-wrap text-center"
                                    },
                                    [
                                      _c("Skeleton", {
                                        attrs: {
                                          circle: "",
                                          height: "50px",
                                          width: "50px",
                                          count: 1
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      ref: "keywords-" + row.id,
                                      refInFor: true,
                                      staticClass: "text-wrap"
                                    },
                                    [_c("Skeleton", { attrs: { count: 1 } })],
                                    1
                                  )
                                ])
                              })
                            : _vm._e()
                        ]
                      : [_vm._m(2)]
                  ]
            ],
            2
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-footer" },
      [
        _c(
          "router-link",
          { attrs: { to: { name: "monitoring_scrape_list" } } },
          [_vm._v("Lihat Semua Scrape")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h3", { staticClass: "card-title mb-0" }, [_vm._v("Scrape Terakhir")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Judul")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Marketplace")]),
        _vm._v(" "),
        _c("th", [_vm._v("Keyword")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "text-center", attrs: { colspan: "3" } }, [
        _vm._v("Tidak ada data yang tersedia")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-760575c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-760575c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard/components/lastScrape.vue
// module id = null
// module chunks = 